import PropTypes from 'prop-types';

const ProgressCircle = ({
  borderColor,
  innerColor,
  progress,
  progressColor,
  size,
  title,
}) => {
  const getDefaultClasses = () => {
    const classes = [];
    if (!borderColor) {
      classes.push('stroke-gray-2');
    }
    if (!innerColor) {
      classes.push('fill-white');
    }
    return classes.join(' ');
  };

  const getProgressColor = () => {
    if (progress >= 90) {
      return 'stroke-green-3';
    }
    if (progress >= 50) {
      return 'stroke-orange-3';
    }
    return 'stroke-red-3';
  };

  return (
    <svg
      className="inline-block"
      height={`${size}`}
      role="img"
      viewBox="0 0 36 36"
      width={`${size}`}
    >
      <title>{title}</title>
      <path
        className={getDefaultClasses()}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill={`${innerColor}`}
        stroke={`${borderColor}`}
        strokeWidth={4}
      />
      <path
        className={`animate-progress-circle ${
          !progressColor && getProgressColor()
        }`}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke={`${progressColor}`}
        strokeDasharray={`${progress} 100`}
        strokeLinecap="round"
        strokeWidth={4}
      />
    </svg>
  );
};

ProgressCircle.propTypes = {
  /**
   * Override for base border color.
   */
  borderColor: PropTypes.string,
  /**
   * Override for color of inner circle.
   */
  innerColor: PropTypes.string,
  /**
   * Percent complete.
   */
  progress: PropTypes.number.isRequired,
  /**
   * Override for progress color.
   */
  progressColor: PropTypes.string,
  /**
   * Size (height and width are equal).
   */
  size: PropTypes.number,
  /**
   * Title of SVG.
   */
  title: PropTypes.string.isRequired,
};

ProgressCircle.defaultProps = {
  borderColor: null,
  innerColor: null,
  progressColor: null,
  size: 40,
};

export default ProgressCircle;
